import { get } from 'lodash';
import { createPermissionCheck } from 'common/utils/helpers';
import { isDeviceOnline, isGa2Device } from 'common/utils/deviceTwinUtils';

const SU_KEY_REGEX = /su|SU\d+/;

export const canCommissionGA2 = createPermissionCheck(['cm_get_raster_heatmap', 'cm_create_raster_heatmap']);

export function validateCommissionGA2Device(device) {
  if (!device) {
    return { valid: false, message: 'No device' };
  }

  if (!isGa2Device(device)) {
    return { valid: false, message: 'Device is not GA2' };
  }

  if (!isDeviceOnline(device)) {
    return { valid: false, message: 'Pivot device is offline' };
  }

  const serviceUnitRecord = getServiceUnitRecord(device);
  const serviceUnits = Object.values(serviceUnitRecord);
  const provisionedServiceUnits = serviceUnits.filter((serviceUnitInfo) =>
    Boolean(get(serviceUnitInfo, 'provision-info.expected-serial-id'))
  );

  if (provisionedServiceUnits.length === 0) {
    return { valid: false, message: 'There are no SUs provisioned on device. Please provision SU devices first' };
  }

  for (let serviceUnitInfo of provisionedServiceUnits) {
    if (!isServiceUnitSerialIdDetected(serviceUnitInfo) || !isServiceUnitNETypeDetected(serviceUnitInfo)) {
      return { valid: false, message: 'Provisioned SUs do not match detected SUs. Please verify provisioning info' };
    }

    if (!isServiceUnitAtBaseline(serviceUnitInfo)) {
      return { valid: false, message: 'One or more SUs are not properly at software baseline' };
    }
  }

  return { valid: true };
}

function getServiceUnitRecord(device) {
  const reported = get(device, 'properties.reported', {});

  const suKeys = Object.keys(reported).filter((key) => SU_KEY_REGEX.test(key));

  return suKeys.reduce((acc, key) => {
    acc[key] = reported[key];
    return acc;
  }, {});
}

function isServiceUnitSerialIdDetected(serviceUnitInfo) {
  const expected = get(serviceUnitInfo, 'provision-info.expected-serial-id');
  const detected = get(serviceUnitInfo, 'provision-info.detected-serial-id');

  return detected != null && detected === expected;
}

function isServiceUnitNETypeDetected(serviceUnitInfo) {
  const expected = get(serviceUnitInfo, 'provision-info.expected-ne-type');
  const detected = get(serviceUnitInfo, 'provision-info.detected-ne-type');

  return detected != null && detected === expected;
}

function isServiceUnitAtBaseline(serviceUnitInfo) {
  const statusCode = get(serviceUnitInfo, 'baselining-status.update-status-code');
  return statusCode === 10 || statusCode === 'atBaseline';
}
